import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PenLineIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(1, 1.5)">
        <path
          d="M11.4144 2.0791C11.4144 1.98092 11.3953 1.8837 11.3577 1.79297C11.3201 1.70207 11.2642 1.61938 11.1947 1.5498C11.1252 1.48032 11.0433 1.42435 10.9525 1.38672C10.8616 1.34907 10.7638 1.33008 10.6654 1.33008C10.4667 1.33008 10.2766 1.40935 10.1361 1.5498L1.93197 9.75195L1.57845 11.165L2.99056 10.8125L11.1947 2.60938C11.2642 2.53984 11.3201 2.45705 11.3577 2.36621C11.3954 2.27531 11.4144 2.17749 11.4144 2.0791ZM12.6654 11.4141C13.0326 11.4141 13.3303 11.7119 13.3304 12.0791C13.3304 12.4464 13.0326 12.7441 12.6654 12.7441H6.66536C6.29809 12.7441 6.00032 12.4464 6.00032 12.0791C6.00041 11.7119 6.29815 11.4141 6.66536 11.4141H12.6654ZM12.7445 2.0791C12.7445 2.35215 12.6908 2.62274 12.5863 2.875C12.4818 3.1272 12.3291 3.35677 12.1361 3.5498L3.80208 11.8828C3.71692 11.9679 3.6103 12.0284 3.49349 12.0576L0.826497 12.7246C0.599939 12.7812 0.359787 12.7149 0.194661 12.5498C0.0295644 12.3847 -0.0367504 12.1445 0.019856 11.918L0.686848 9.25098C0.716098 9.1342 0.776545 9.02752 0.861653 8.94238L9.19466 0.609375C9.58459 0.219447 10.1139 0 10.6654 0C10.9384 0 11.209 0.0537127 11.4613 0.158203C11.7135 0.262692 11.943 0.41634 12.1361 0.609375C12.3289 0.802277 12.4818 1.03125 12.5863 1.2832C12.6907 1.53542 12.7444 1.80611 12.7445 2.0791Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PenLineIcon.displayName = 'PenLineIcon';
